import { Plugin } from "prosemirror-state";
import { ReactPluginView } from "../../react/react-plugin-view";
import { disableMenu, enableMenu, floatingMenuPluginKey, MenuPluginState, staticMenuPluginKey, } from "./state";
import { EditorFloatingToolbarPluginView } from "./components/EditorFloatingToolbarPluginView";
import { EditorStaticToolbarPluginView } from "./components/EditorStaticToolbarPluginView";
export function floatingToolbarPlugin(portalContainer, commands, items, showDividers) {
    return new Plugin({
        key: floatingMenuPluginKey,
        state: new MenuPluginState(),
        props: {
            handleDOMEvents: {
                // Hides menu when editor loses focus
                blur: (view) => {
                    view.dispatch(disableMenu(view.state.tr));
                    return false;
                },
                // Re-enable menu when editor receives focus
                focus: (view) => {
                    view.dispatch(enableMenu(view.state.tr));
                    return false;
                },
            },
        },
        view: ReactPluginView.create({
            portalContainer,
            component: EditorFloatingToolbarPluginView,
            extraProps: {
                commands,
                items,
                showDividers,
            },
            className: "EditorFloatingToolbarPluginView",
        }),
    });
}
export function staticToolbarPlugin(portalContainer, commands, options, items, showDividers) {
    const dashboardsStyleCommands = options.dashboardsStyle && {
        toggleStrikethrough: null,
        toggleCodeMark: null,
    };
    return new Plugin({
        key: staticMenuPluginKey,
        view: ReactPluginView.create({
            portalContainer,
            component: EditorStaticToolbarPluginView,
            extraProps: {
                commands: {
                    ...commands,
                    ...dashboardsStyleCommands,
                },
                mode: options.mode,
                disableTooltips: options.disableTooltips,
                items,
                showDividers: options.showToolbarButtonDividers,
                showArrows: options.showToolbarButtonArrows,
            },
            domInsertMode: options.mode === "static-footer" ? "append" : "prepend",
            className: "EditorStaticToolbarPluginView",
        }),
    });
}
